export const processRiders = (benefits: any[]) => {
	const trueRiderTemp: any = {};
	const riderTemp: any = {};

	benefits.forEach((benefit: any) => {
		// // console.log("Benefits------->", benefit);
		// console.log("Plan Insured SSN:", benefit.insured_SSN);
		(benefit.enrollments || []).forEach((enrollment: any) => {
			if (enrollment.base_plan_name !== enrollment.plan_name) {
				// Check if this enrollment is already in riderTemp
				// // console.log("doing wait");
				const base_plan_name = enrollment.base_plan_name;
				const plan_code = enrollment.plan_code;
				if (
					(!(plan_code in trueRiderTemp) && !(plan_code in riderTemp)) ||
					(trueRiderTemp[plan_code] == 0 && riderTemp[plan_code].length == 0)
				) {
					if (!(plan_code in trueRiderTemp)) {
						trueRiderTemp[plan_code] = 0;
					}

					if (!(plan_code in riderTemp)) {
						riderTemp[plan_code] = [];
					}
					trueRiderTemp[plan_code] += 1;
					// console.log("Enrollment Particular---> 3", enrollment);
					riderTemp[plan_code].push(enrollment); // Add to riderTemp if not a duplicate
				}
			}
		});
	});

	// console.log("true", trueRiderTemp, riderTemp);

	return { trueRiderTemp, riderTemp };
};
